// This file is auto-generated by @hey-api/openapi-ts

export type InitResponse = {
    requestId: string;
    autoStartToken: string;
};

export type CheckResponse = {
    qrCode: string;
    hintCode: string;
    status: CheckResponseStatus;
    errorCode?: ErrorCodeStatus;
};

export enum CheckResponseStatus {
    Complete = 0,
    UserSign = 1,
    OutstandingTransaction = 2,
    NoClient = 3,
    UserReq = 4,
    Started = 5,
    Failed = 6,
    Unknown = 100
}

export enum ErrorCodeStatus {
    INVALID_PARAMETERS = 0,
    ACCESS_DENIED_RP = 1,
    RETRY = 2,
    INTERNAL_ERROR = 3,
    ALREADY_COLLECTED = 4,
    EXPIRED_TRANSACTION = 5,
    TIMEOUT = 6,
    USER_CANCEL = 7,
    CLIENT_ERR = 8,
    CERTIFICATE_ERR = 9,
    CANCELLED = 10,
    START_FAILED = 11,
    ALREADY_IN_PROGRESS = 12,
    REQ_PRECOND = 13,
    REQ_ERROR = 14,
    REQ_BLOCKED = 15,
    SIGN_VALIDATION_FAILED = 16,
    TIME_BLOCKED = 17,
    UNKNOWN_USER = 18,
    INVALID_DEVICESW = 19,
    Unknown = 100
}

export type AlertResponse = {
    id: string;
    title?: string;
    type?: string;
    text?: string;
    icon?: string;
    dismissable?: boolean;
};

export type ContactInformation = {
    email?: string;
    mobile?: string;
    lastUpdatedEmail?: Date;
    lastUpdatedMobile?: Date;
    contactOutdated?: boolean;
};

export type UpdateContactInformationRequest = {
    email: string;
    mobile: string;
};

export enum ErrorCode {
    GenericError = 0,
    InvalidIpAddress = 1,
    BankIdError = 2,
    BankIdMissingSsn = 3,
    UserNotInMaster = 4,
    InvalidReturnUrl = 5,
    BlockedUser = 6,
    UnauthorizedAccess = 7,
    BankIdReqestNotFound = 8
}

export type InitDeprecatedResponse = (InitResponse);

export type InitData = {
    sameDevice: boolean;
};

export type InitResponse2 = (InitResponse);

export type CheckData = {
    requestId: string;
};

export type CheckResponse2 = (CheckResponse);

export type GetAlertsResponse = (Array<AlertResponse>);

export type GetContactInformationData = {
    requestId: string;
};

export type GetContactInformationResponse = (ContactInformation);

export type UpdateContactInformationData = {
    requestBody: UpdateContactInformationRequest;
    requestId: string;
};

export type UpdateContactInformationResponse = (unknown);